export default __webpack_public_path__ + "static/media/DharmaGothicE_ExBold_I.4e423683.otf";